
export const CP_TYPE_LIST = ['CP', 'CP4D'];
export const NCP_TYPE_LIST = ['NCP', 'NCP4D'];
